import PropTypes from "prop-types";
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

// project import
import useAuth from "hooks/useAuth";

// ==============================|| GUEST GUARD ||============================== //

const RentGuard = ({ children }) => {
  const { isLoggedIn, user } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (isLoggedIn && user.is_requester) {
      navigate("rent", {
        state: {
          from: "",
        },
        replace: true,
      });
    }
  }, [isLoggedIn, navigate, location, user]);

  return children;
};

RentGuard.propTypes = {
  children: PropTypes.node,
};

export default RentGuard;
